<template>
  <span class="pill" :style="pillStyle">
    <slot />
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  color: { type: String, default: 'var(--primary)' },
  bg:    { type: String, default: 'var(--primary-soft)' },
})

const pillStyle = computed(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  padding: '4px 10px',
  borderRadius: '999px',
  background: props.bg,
  color: props.color,
  fontFamily: 'var(--ff-body)',
  fontWeight: 700,
  fontSize: '11px',
  letterSpacing: '0.4px',
  textTransform: 'uppercase',
}))
</script>
